import getConfig from 'next/config';
import { Logger } from '@magalu/mixer-utils';

export default Logger(getConfig());
